<header>
	<app-navbar></app-navbar>
</header>
<main id="main">
	<router-outlet></router-outlet>
</main>
<app-footer></app-footer>